import { CommonModule } from "@angular/common";
import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { BRAND, BRAND_PATH } from "src/app/authentication/model/auth.enum";
import { RfAuthenticationService } from "src/app/authentication/rf-authentication.service";
import { HeaderComponent } from "src/app/core/header/header.component";
import { MaterialModule } from "src/app/shared/module/material.module";

@Component({
  selector: "ald-welcome",
  templateUrl: "./welcome.component.html",
  styleUrls: ["./welcome.component.scss"],
  standalone: true,
  imports: [
    HeaderComponent,
    MaterialModule,
    CommonModule
  ]
})
export class WelcomeComponent implements OnInit {
  constructor(private authService: RfAuthenticationService) {}
  @Output() loginEmitter = new EventEmitter();
  image: any = {};
  ngOnInit(): void {}

  loadImage(): BRAND_PATH {
    const hostname = window.location.hostname;
    switch (hostname) {
      case BRAND.FORD: {
        this.defineImgeObj(BRAND_PATH.FORD);
        return BRAND_PATH.FORD;
      }
      case BRAND.HONDA: {
        this.defineImgeObj(BRAND_PATH.HONDA);
        return BRAND_PATH.HONDA;
      }
      case BRAND.JAGUAR: {
        this.defineImgeObj(BRAND_PATH.JAGUAR);
        return BRAND_PATH.JAGUAR;
      }
      case BRAND.LAND_ROVER: {
        this.defineImgeObj(BRAND_PATH.LAND_ROVER);
        return BRAND_PATH.LAND_ROVER;
      }
      case BRAND.SUZUKI: {
        this.defineImgeObj(BRAND_PATH.SUZUKI);
        return BRAND_PATH.SUZUKI;
      }
      case BRAND.OMODA_JAECOO: {
        this.defineImgeObj(BRAND_PATH.OMODA_JAECOO);
        return BRAND_PATH.OMODA_JAECOO;
      }
      case BRAND.MG: {
        this.defineImgeObj(BRAND_PATH.MG);
        return BRAND_PATH.MG;
      }
      case BRAND.FFM: {
        this.defineImgeObj(BRAND_PATH.FFM);
        return BRAND_PATH.FFM;
      }
      default: {
        this.defineImgeObj(BRAND_PATH.AYVENS);
        return BRAND_PATH.AYVENS;
      }
    }
  }

  getClassForImageRender(): any {
    return this.image.styleName;
  }

  defineImgeObj(src): void {
    this.image.src = src;
    let hostname = this.image.src.match(/[ \w-]+\./);
    hostname = hostname[0].replaceAll(".", "");
    this.image.styleName =
      hostname === "aldautomotive" ? "image-standard " : "image-brand ";
  }

  login(): void {
    if (!this.authService.isLogIn()) {
      this.authService.configureAndRefresh(this.getAsscodeFromQueryParam());
    }
  }

  isNotLogged(): boolean {
    return this.authService.isLogIn() ? false : true;
  }
  getAsscodeFromQueryParam(): string {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const associationCode = urlParams.get("associationCode");
    return associationCode;
  }

  backHome(): void {}
}
